import { GetHolidaysPayload } from '@pages/PublicHolidayCalendar/types';
import { AxiosInstance } from 'axios';

export default class PublicHolidayCalendarAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getCalendars() {
    return this.client.get('/v2/reporting/calendars/pmca/');
  }

  async getHolidays(payload: GetHolidaysPayload) {
    return this.client.post('/v2/timekeeping/return-holidays/', payload);
  }

  async downloadCalendarReport(payload: { year: number; calendar_id_list: number[] }) {
    return this.client.post('/v2/timekeeping/download-public-holiday-calendar-report/', payload);
  }
}
